// 初期表示
export const PAGE_INIT = "corp/overseas/index/PAGE_INIT";
// 株式情報
export const LOAD_CODE_INFO = "corp/overseas/index/LOAD_INFO";
// 株価チャート情報取得
export const LOAD_CHART = "corp/overseas/index/LOAD_CHART";
// Excelダウンロード期間取得
export const LOAD_DATE = "corp/overseas/index/LOAD_DATE";
